module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFhJREFUeNpiFD967woDA4MkA3ngPQuQkAdiHjINYGUCEr8YyAe/mRgoBKMGjBoASoks6GkbiP+TmhcYoZw2IO4j0YD/IAMEgHgqEFeTGwYgm3PJDQSAAAMASm0N61XH4KIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/clubActivity/icons/comment.png
// module id = 389
// module chunks = 438